import { createAsyncThunk } from '@reduxjs/toolkit';
import DocuSignEnvelopeRestApi, { DataForCreatingDocuSignEnvelope } from 'api/DocuSignEnvelopeApi';

import { ErrorResponse } from './ErrorResponse';

export const createDocuSignEnvelopeThunk = (api: DocuSignEnvelopeRestApi) =>
  createAsyncThunk(
    'docuSignEnvelope/createDocuSignEnvelope',
    async (data: DataForCreatingDocuSignEnvelope, thunkApi) => {
      try {
        return await api.createEnvelope(data);
      } catch (error: unknown) {
        thunkApi.rejectWithValue((error as ErrorResponse).response.data);

        throw error;
      }
    },
  );
